export default __webpack_public_path__ + "e71ee38e631798f384613be6596ded62.svg";